import React, { Component } from "react";
import { MessageBox } from "react-chat-elements";
import { UserOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Flex, Space } from "antd";

class ContactMessageBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { msg, dateFormatter } = this.props;

    return (
      <div>
        <MessageBox
          type={"text"}
          dateString={dateFormatter(msg.timestamp)}
          position={msg.owner === "client" ? "left" : "right"}
          title={msg.owner === "client" ? undefined : msg.owner}
          className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
          text={
            <Flex
              gap="middle"
              wrap="wrap"
              style={{
                padding: "16px",
                borderRadius: "25px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <Space>
                <UserOutlined />
                {msg.content.name.formatted_name}
              </Space>
              <ArrowRightOutlined />
              <Space>{msg.content.phones[0].phone}</Space>
            </Flex>
          }
        />
      </div>
    );
  }
}

export default ContactMessageBox;



// WEBPACK FOOTER //
// ./src/views/NaduChat/components/ContactMessageBox.jsx